import React from "react";

const Academic = () => {
    return (
        <svg width="30" height="16" viewBox="0 0 37 23" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M30.7 8.53L17.4 13.7L1 7.3L17.4 1L33.9 7.38V17.68" stroke="#000" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M33.8639 21.678C34.9718 21.678 35.8699 20.7799 35.8699 19.672C35.8699 18.5641 34.9718 17.666 33.8639 17.666C32.756 17.666 31.8579 18.5641 31.8579 19.672C31.8579 20.7799 32.756 21.678 33.8639 21.678Z" stroke="#000" strokeWidth="1.7" strokeLinecap="round"/>
            <path d="M7.25977 9.72998V16.5L17.3098 20.8L27.5298 16.37V10.13" stroke="#000" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    )
}

export default Academic
